import networkAdapter from '../adapters/network';

export const fetchFieldBoundariesByFieldId = ( {userId, fieldId} ) => {
  const legacyOptions = {
    url: `/api/fields/${fieldId}?includeBoundary=true`,
    userId
  };
  
  return networkAdapter({
    legacyOptions
  });
};

export const fetchFieldBoundaryData = ({ fieldId, userId }) => {
  const legacyOptions = {
    url: `/api/fields/${fieldId}`,
    userId
  };
  
  return networkAdapter({
    legacyOptions
  });
};
